import { Flex } from 'antd'

import { T } from '../Text/Text'

import FormControlLabel from './FormControlLabel'
import {
  FormControlProps,
  getCaptionId,
  getErrorMessageId,
  GovWellFormFieldClassName,
  GovwellFormFieldErrorClassName,
  useBaseAriaAttributes,
} from './util'

type Props = FormControlProps & {
  children: (props: ReturnType<typeof useBaseAriaAttributes>) => React.ReactNode
}
const FormControl = (props: Props) => {
  const {
    caption,
    children,
    errorMessage,
    id,
    isInvalid,
    isLabelRedundant,
    isRequired,
    label,
    tooltip,
    width,
  } = props
  const { ariaDescribedBy, ariaInvalid, ariaLive } = useBaseAriaAttributes(props)

  return (
    <Flex
      vertical
      align="flex-start"
      gap="3px"
      style={{
        position: 'relative',
        width,
        minWidth: 0, // This CSS hack is necessary to get form controls to shrink in flex rows
      }}
      className={GovWellFormFieldClassName}
    >
      {label && (
        <FormControlLabel
          id={id}
          isLabelRedundant={isLabelRedundant}
          isRequired={isRequired}
          label={label}
          tooltip={tooltip}
        />
      )}
      {children({ ariaDescribedBy, ariaInvalid, ariaLive })}
      {isInvalid && errorMessage && id && (
        <div id={getErrorMessageId(id)} className={GovwellFormFieldErrorClassName}>
          {typeof errorMessage === 'string' ? (
            <T.BodySmall as="span" className="inline-block text-left text-red-700">
              {errorMessage}
            </T.BodySmall>
          ) : (
            errorMessage
          )}
        </div>
      )}
      {caption && id && (
        <div id={getCaptionId(id)} className="w-full">
          {typeof caption === 'string' ? (
            <T.BodySmall className="text-neutral-500">{caption}</T.BodySmall>
          ) : (
            caption
          )}
        </div>
      )}
    </Flex>
  )
}

export default React.memo(FormControl)
